document.addEventListener('DOMContentLoaded', function() {
    if (window.location.hostname === 'us.revivecollagen.com') {
        replaceText(document.body, /flavours/gi, 'favours');
        replaceText(document.body, /colours/gi, 'colors');
    }
});

function replaceText(element, textToReplace, replacementText) {
    if (element.hasChildNodes()) {
        element.childNodes.forEach(child => {
            replaceText(child, textToReplace, replacementText);
        });
    } else if (element.nodeType === Text.TEXT_NODE) {
        const newText = element.textContent.replace(textToReplace, replacementText);
        if (newText !== element.textContent) {
            const newNode = document.createTextNode(newText);
            element.parentNode.replaceChild(newNode, element);
        }
    }
}
